import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { sendBiEvent } from '../services/bi';
import type { BiEvent } from '../services/events';
import useIsManagedPackageInstalled from '../components/common/install-managed-package/useIsManagedPackageInstalled';
import { selectUserInfoData } from '../reducers/userInfoReducer';

const useSendBiEvent = () => {
  const isManagedPackagedInstalled = useIsManagedPackageInstalled();
  const userInfo = useSelector(selectUserInfoData);

  const sendEvent = useCallback(
    (event: BiEvent) => {
      const extendedProps = {
        ...event.props,
        managedPackagedInstalled: isManagedPackagedInstalled,
        accountName: userInfo?.account?.name,
        userEmail: userInfo?.email,
      };
      const updateEvent: BiEvent = {
        ...event,
        props: extendedProps,
      };
      sendBiEvent(updateEvent);
    },

    [isManagedPackagedInstalled, userInfo?.account?.name, userInfo?.email],
  );

  return sendEvent;
};

export default useSendBiEvent;
